module.exports = __webpack_public_path__ + "img/yimididatoutiao.97d2de8f.png";